// NPM Imports
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Toastr } from "@revvsales/components";
import PropTypes from "prop-types";

// Service Imports
import { initiateSAMLAuthRequestService } from "../../AuthService/authService";

// CSS Imports
import samlAuth from "./samlauth.module.scss";

// Internal Imports
import { GlobalUtils } from "../../utils";

// Destructuring
const { removeCookie, setCookie, removeDataFromLocalStorage } = GlobalUtils;

class SAMLAuth extends React.Component {
  constructor(props) {
    super(props);
    this.state = { samlAuthLoaderBtn: false };
  }

  componentDidMount() {
    // Remove the correct saml user email from the localStorage if added
    removeCookie("samlUserData");
  }

  _initiateSAMLAuthRequest = () => {
    this.setState({ samlAuthLoaderBtn: true });
    initiateSAMLAuthRequestService()
      .then(response => {
        this.setState({ samlAuthLoaderBtn: false });
        // Removing the added "org_id" from localStorage after successful signin and signup
        if (this.props.usedFor === "SIGNIN") {
          removeDataFromLocalStorage("samlLoginOrgId");
        } else if (this.props.usedFor === "SIGNUP") {
          removeDataFromLocalStorage("signupOrgID");
        }
        // Need to add current username(email) in a cookie to
        // cross validate emails after successful SAML redirection
        if (this.props.userName) {
          setCookie(
            "samlUserData",
            JSON.stringify({
              userName: this.props.userName,
              triggeredFrom: "REVV_SAML_LOGIN_FORM",
            }),
          );
        }
        if (response && response.auth_url) {
          window.open(response.auth_url);
        } else {
          Toastr.showToastr({
            type: "failure",
            message: "Something went wrong. Please try again!",
          });
        }
      })
      .catch(error => {
        console.error(
          `SAMLAuth => _initiateSAMLAuthRequest => Error : ${error}`,
        );
        Toastr.showToastr({
          type: "failure",
          message: "Something went wrong. Please try again!",
        });
        this.setState({ samlAuthLoaderBtn: false });
      });
  };

  render() {
    return (
      <div
        className={`${samlAuth.signingSmalAuthButton} ${
          this.state.samlAuthLoaderBtn ? samlAuth.showInlineBtnLoader : "  "
        }`}
        onClick={
          !this.state.samlAuthLoaderBtn
            ? this._initiateSAMLAuthRequest
            : () => {}
        }
        onKeyPress={() => {}}
        role="button"
        tabIndex="0">
        <span className={samlAuth.signingSmalAuthIconWrapper}>
          {/* Button icon */}
          <FontAwesomeIcon
            icon={["fas", "lock-alt"]}
            className={samlAuth.signingSmalAuthIcon}
          />
          {/* Button inline loader */}
          {this.state.samlAuthLoaderBtn && (
            <div className={samlAuth.signinInlineBtnLoader}>
              <FontAwesomeIcon icon={["far", "spinner"]} className="fa-spin" />
            </div>
          )}
        </span>
        {/* Button title */}
        <span className={samlAuth.signingSmalAuthTitle}>
          {this.props.title}
        </span>
      </div>
    );
  }
}

SAMLAuth.defaultProps = {
  title: "SAML-SSO",
};

SAMLAuth.propTypes = {
  title: PropTypes.string,
  userName: PropTypes.string.isRequired,
  usedFor: PropTypes.string.isRequired,
};

export default SAMLAuth;
